import { concatUrl } from './base'
import { appRequest } from './request'
import store from './../store/index'
import {userInfo} from "@/service/user";

//获取枚举常量数据  /client/loadAllDictionary
export async function getLoadAllDictionary() {
  const url = concatUrl(`/client/loadAllDictionary`)
  return appRequest(url, {
    method: 'GET'
  })
}

//从本地vuex 状态管理库 获取缓存的字典数据 没有重新请求数据
export async function getLoadAllDictionaryByKey(dictionaryType) {
  let dictionaryList = []
  let LocalLoadAllDictionary = store.state.base.loadAllDictionary
  if (!LocalLoadAllDictionary || !LocalLoadAllDictionary.length) {
    await store.dispatch('getLoadAllDictionary')
  }
  LocalLoadAllDictionary = store.state.base.loadAllDictionary
  LocalLoadAllDictionary.forEach(dictionary => {
    if (dictionary.type === dictionaryType) {
      dictionaryList = dictionary.values && dictionary.values.length ? dictionary.values : []
    }
  })
  return dictionaryList
}

//个人客户 证件类型
export async function idCardsType() {
  return  await  getLoadAllDictionaryByKey('idType')
}

//机构客户 证件类型
export async function branchIdCardsType() {
  return getLoadAllDictionaryByKey('branchIdType')
}

//根据客户证件类型value 值获取证件类型name
export async function getIdNoTypeNameByValue(idValue) {
  let {customer_type: customerType} = await userInfo()//客户类型
  let idName = null
  if (customerType === '0') {//机构
    let branchIdTypes = await branchIdCardsType()
    branchIdTypes.some(item => {
      if (item.value === idValue) {
        idName = item.name
        return true
      }
    })
  } else {//其他客户类型
    let result = await idCardsType()
    result.some(item => {
      if (item.value === idValue) {
        idName = item.name
        return true
      }
    })
  }
  return idName
}